import { EnumBrewmanBarcodeType } from "@/app/services/generated/enums/enumBrewmanBarcodeType.generated";

/**
 * Check if a barcode's format matches a defined EnumBrewmanBarcodeType
 * @param barcode Barcode string
 * @returns Barcode type if valid, otherwise returns barcode type none
 */
export function validateBrewmanBarcode(
  barcode: string
): EnumBrewmanBarcodeType {
  const firstCharacter = barcode.toUpperCase().charAt(0);
  const lastCharacter = barcode.toUpperCase().charAt(barcode.length - 1);

  // check for v6 journey label
  if (firstCharacter === "J" && lastCharacter === "L") {
    return EnumBrewmanBarcodeType.v6JourneyLabel;
  }

  // check for v6 perm label
  if (isNaN(Number(firstCharacter)) && !isNaN(Number(lastCharacter))) {
    return EnumBrewmanBarcodeType.v6PermLabel;
  }

  // check for tracking, batch, pallet and ullage
  if (barcode.length == 12 && !isNaN(Number(barcode))) {
    let barcodeType = parseInt(barcode.substring(0, 2));
    if (
      EnumBrewmanBarcodeType.getValues().some((x) => x.key == barcodeType) &&
      validateCheckDigit(barcode)
    ) {
      return EnumBrewmanBarcodeType.getByKey(barcodeType);
    }
  }

  return EnumBrewmanBarcodeType.none;
}

function validateCheckDigit(barcode: string) {
  let sum = 0;
  for (let i = barcode.length - 1; i >= 0; i--) {
    let selected = parseInt(barcode[i]);
    if (i % 2 == 0) {
      let doubleDigit = selected * 2;
      if (doubleDigit > 9) {
        sum += (doubleDigit % 10) + 1;
      } else {
        sum += doubleDigit;
      }
    } else {
      sum += selected;
    }
  }
  return sum % 10 == 0;
}
